<template>
  <div id="app" v-cloak>
    <top-nav :color="color"></top-nav>
    <transition mode="out-in">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </transition>
    <footer-bot class data-ani></footer-bot>
  </div>
</template>

<script>
import topNav from "./components/top";
import footerBot from "./components/footerBot";
import { CountUp } from "../node_modules/countup.js/dist/countUp.js";
export default {
  data() {
    return {
      transitionName: "",
      toDepth: 0,
      fromDepth: 0,
      color: 'light'
    };
  },
  components: {
    topNav,
    footerBot
  },
  watch: {
    $route(to, from) {
      const routeDeep = [
        "/",
        "/home",
        "/about",
        "/product",
        "/solution",
        "/joinUs",
        "/joinUsDetail"
      ];
      this.toDepth = routeDeep.indexOf(to.path) || 0;
      this.fromDepth = routeDeep.indexOf(from.path) || 0;
      this.transitionName =
        this.toDepth > this.fromDepth ? "slide-left" : "slide-right";
      console.log(to.name)
      // if (to.name == 'face' || to.name == 'body' || to.name == 'auto' || to.name == 'object' || to.name == 'about' || to.name == 'server' || to.name == 'facecapture' || to.name == 'androidaccess' || to.name == 'dualchannel') {
      //   this.color = 'dark'
      // } else {
      //   this.color = 'light'
      // }
    }
  },
  mounted() {
    this.transitionName =
      this.toDepth > this.fromDepth ? "slide-left" : "slide-right";
  },
  methods: {
    handleScroll() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (top > 250) {
        this.isFixed = 1;
      } else if (top < 200) {
        this.isFixed = 0;
      }
    },
    handleAnimate() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          console.log(v.offsetTop);
          var delay = true;
          var hasClass = v.classList.contains("active");
          if (delay && !hasClass) {
            v.classList.add("active");
            setTimeout(() => {
              v.style.opacity = 1;
              console.log(v.offsetTop);
              let demo = new CountUp("myTargetElement", 50);
              let demo1 = new CountUp("myTargetElement1", 100);
              let demo2 = new CountUp("myTargetElement2", 24);
              if (!demo.error) {
                demo.start();
              } else {
                console.error(demo.error);
              }
              if (!demo1.error) {
                demo1.start();
              } else {
                console.error(demo1.error);
              }
              if (!demo2.error) {
                demo2.start();
              } else {
                console.error(demo2.error);
              }
            }, delay);
          } else {
            console.log(v);
          }
        } else {
          v.classList.remove(v.dataset.ani);
          v.style.opacity = 1;
        }
      });
    },
    showAnimate(e) {
      this["flag" + e] = !this["flag" + e];
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.handleAnimate(); //初始化第一次加载时在视口内就执行动画
      addEventListener("scroll", this.handleScroll);
      addEventListener("scroll", this.handleAnimate);
    });
  },
  destroyed() {
    removeEventListener("scroll", this.handleScroll); //避免影响其他页面
    removeEventListener("scroll", this.handleAnimate);
  }
};
</script>
<style lang="less">
html,
body,
#app {
  height: 100%;
  padding: 0;
  margin: 0;
  width: 100%;
  // overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  // position: relative;
}
#app {
  font: 16px microsoft yahei, arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.w-100 {
  max-width: unset;
  width: auto;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 600ms linear;
  // position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translateX(50%);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translateX(-50%);
}
.slide-left-enter {
  opacity: 0;
  transform: translateX(50%);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translateX(-50%);
}

.animate {
  opacity: 0;
}

.fadeInRouter {
  animation: fadeIn 0.1s ease-out;
}
.fadeOutRouter {
  animation: fadeOut 0.1s ease-in;
}
.fadeIn {
  animation: fadeIn 2s ease-in;
}
.fadeInFast {
  animation: pulse 1s ease-in;
}
.rollIn {
  animation: rollIn 1s;
}
.slideInRight {
  animation: slideInRight 1s;
}
.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}
.bounceInRight {
  animation: bounceInRight 2s ease-in;
}
</style>
